import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  preFooter: {
    backgroundImage: `url('/images/pre_footer.png')`,
    backgroundPosition: 'center bottom',
    height: 60,
  },
});

const PreFooter = () => {
  const { preFooter } = useStyles();
  return <div className={preFooter} />;
};

export default PreFooter;
